import React, {Component} from 'react';
import {Card, CardContent, CardHeader, Typography} from "@mui/material";

class CustomCardComponent extends Component {

    render() {
        return(
            <Card sx={{
                minWidth: 350,
                background: this.props.background,
                color: 'white'
            }}>
                <CardHeader sx={{fontSize: 14}} title={<b>{this.props.title}</b>}/>
                <CardContent>
                    <Typography sx={{fontSize: 16}} color={"white"}>
                        {this.props.text}
                    </Typography>
                </CardContent>
            </Card>
        );
    };
}

export default CustomCardComponent;